import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
// services
import { CoreChatStore } from '../../core-chat.store';

@Component({
  selector: 'core-chat-shortcut',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './shortcut.component.html',
})
export class CoreChatShortcutComponent {
  private store = inject(CoreChatStore);

  //#region events
  onClickQuickCommand(event: MouseEvent, command: 'hs' | 'un') {
    event.defaultPrevented;
    event.stopPropagation();

    this.store.setQuickCommand(command);
  }
  //#endregion
}
